module.exports = __webpack_public_path__ + "static/media/es-ES.1bd2d68b.md";